"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = anonymousTrack;
var _uuid = require("uuid");
var _common = require("./common");
function anonymousTrack(config, event) {
  var _user$session;
  var amplitudeToken = config.amplitudeToken,
    user = config.user;
  var data = event.data;
  var amplitudeEvent = data.amplitudeEvent,
    amplitudeUserProperties = data.amplitudeUserProperties;

  // Bail if no Amplitude token, admin impersonation, or no amplitude event in data
  if (!amplitudeToken || user !== null && user !== void 0 && (_user$session = user.session) !== null && _user$session !== void 0 && _user$session.isAdminImpersonation || !amplitudeEvent) {
    return;
  }
  var eventData = (0, _common.prepareEventProperties)(amplitudeEvent, data);

  // Generate unique uuid for device ID
  var deviceId = (0, _uuid.v4)();

  // Send the event via beacon to avoid any built in cookie Action
  try {
    navigator.sendBeacon('https://api2.amplitude.com/2/httpapi', JSON.stringify({
      api_key: amplitudeToken,
      events: [{
        device_id: deviceId,
        user_id: '',
        event_type: amplitudeEvent,
        event_properties: eventData,
        user_properties: {
          $set: amplitudeUserProperties
        },
        ip_address: '$remote',
        user_agent: navigator.userAgent,
        language: navigator.language,
        platform: 'Web'
      }]
    }));
  } catch (error) {
    console.error(error);
  }
}
module.exports = exports.default;